import { render, staticRenderFns } from "./OwnerMenu.vue?vue&type=template&id=ec5920c6"
import script from "./OwnerMenu.vue?vue&type=script&lang=js"
export * from "./OwnerMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports